import { useTranslation } from "react-i18next";
import { PainAreaAndScale } from "../../models/enumerations/pain-area-and-scale";
import DotScale from "../dot-scale/dot-scale";
import MskScoreUtil from "../../utilities/msk-score-util";

const COMPONENT_CLASS = "c-user-profile-pain-areas-and-scales";

const PAIN_COLORS = [
    "#43B5F8", // blue-dark
    "#00DFBC", // green-dark
    "#FFC79C", // yellow-dark
    "#5225BB", // purple-dark
    "#E7514F", // red-dark
];


export interface UserProfilePainAreasAndScalesProps {
    // Define props here as needed
    painAreasAndScales: PainAreaAndScale[];
}

const UserProfilePainAreasAndScales: React.FC<UserProfilePainAreasAndScalesProps> = (props: UserProfilePainAreasAndScalesProps) => {
    const { painAreasAndScales } = props;
    const { t } = useTranslation();

    return (
        <div className={COMPONENT_CLASS}>
            <h3 className="text-base font-normal">
                {t('userProfile.assessments.painInjuryLocations')}
            </h3>

            <div className={`${COMPONENT_CLASS}__dot-scale-row`}>
                {painAreasAndScales.map((item, index) => {
                    const fillColor = PAIN_COLORS[index % PAIN_COLORS.length];

                    return (
                        <div key={index} className={`${COMPONENT_CLASS}__dot-scale-wrapper`}>
                            <DotScale
                                fillColor={fillColor}
                                totalDots={10}
                                dotScaleValue={item.scale}
                                headerText={MskScoreUtil.getPainHeaderText(item.area, item.direction)}
                                bottomLeftLabel={t("app.sliderLabels.noPain")}
                                bottomRightLabel={t("app.sliderLabels.severePain")}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default UserProfilePainAreasAndScales;